<template>
  <div>
    <v-card v-if="gettingCustomers" class="mt-12" flat>
      <div class="d-flex flex-column align-items-center mt-8 py-6">
        <atom-spinner
          :animation-duration="1000"
          :size="80"
          :color="'#6200ea'"
        />
        <p class="primary--text font-weight-bold mt-4" style="color: #6200ea">
          در حال بارگذاری اطلاعات...
        </p>
      </div>
    </v-card>

    <div v-else class="new-invoice pb-9">
      <i
        hidden
        class="mr-3 fa fa-question-circle text-dark"
        @click="toggleHelp()"
        v-shortkey.once="['q']"
        @shortkey="toggleHelp()"
      ></i>
      <v-dialog v-model="guide" persistent width="700">
        <v-card class="dialog-card pa-0">
          <v-card-title class="text-center">
            <h4>
              برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
            </h4>
          </v-card-title>
          <v-card-text class="pt-3">
            <!-- <v-btn elevation="6" outlined small
              ><i class="fa fa-arrow-left text-dark"></i
            ></v-btn>
            تب بعدی <br /> -->
          </v-card-text>
          <v-card-subtitle>
            <v-btn
              elevation="3"
              height="45"
              color="grey darken-1"
              class="me-3"
              outlined
              small
              style="border-radius: 6px !important; font-size: 17px !important"
              >q
            </v-btn>
            <b>بستن این راهنما</b>
          </v-card-subtitle>
        </v-card>
      </v-dialog>
      <v-card class="common-card">
        <div class="d-flex flex-row">
          <v-col xl="10" lg="10" md="10" sm="8" xs="12" cols="12">
            <h4 class="c-grey pt-2 ps-2 fs-large">
              جزئیات فاکتور {{ invoiceData.code }} (وضعیت:
              {{ invoiceData.status }})
            </h4>
          </v-col>

          <v-col xl="2" lg="2" md="2" sm="4" xs="12" cols="12">
            <v-btn
              @click="goToPrint()"
              :loading="loading"
              block
              class="purple white--text"
            >
              برچسب پستی
            </v-btn>
          </v-col>
        </div>

        <hr class="mt-3" />
        <div class="mt-5">
          <div class="mt-5" style="font-size: 1rem">
            <v-row class="px-2">
              <v-col sm="6" cols="12">
                <b class="fs-medium2 ml-1">نام مشتری: </b>
                <span>
                  {{
                    invoiceData.shopCustomerName
                      ? invoiceData.shopCustomerName
                      : " - "
                  }}
                </span>
              </v-col>
              <v-col sm="6" cols="12">
                <b class="fs-medium2 ml-1">تاریخ خرید: </b>
                <span>{{ invoiceData.date }}</span>
              </v-col>
            </v-row>

            <v-row class="px-2">
              <v-col sm="6" cols="12">
                <b class="fs-medium2 ml-1">کد مشتری: </b>
                <span>
                  {{
                    invoiceData.shopCustomerCode
                      ? invoiceData.shopCustomerCode
                      : " - "
                  }}
                </span>
              </v-col>
              <v-col sm="6" cols="12">
                <b class="fs-medium2 ml-1">شماره سفارش: </b>
                <span>{{ invoiceData.code }}</span>
              </v-col>
            </v-row>

            <v-row class="px-2">
              <v-col sm="6" cols="12">
                <b class="fs-medium2 ml-1">شماره همراه مشتری: </b>
                <span>{{
                  invoiceData.shopCustomerMobile
                    ? invoiceData.shopCustomerMobile
                    : "-"
                }}</span>
              </v-col>
            </v-row>
          </div>
          <hr />
          <span v-show="false">{{ reactivity }}</span>
          <div class="custom-table bordered mt-5 pb-1">
            <b-table
              responsive
              show-empty
              :items="invoiceData.details"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="هنوز کالایی به فاکتور اضافه نشده است"
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-icon class="red--text text--lightem-1 me-2"
                    >mdi-alert-circle-outline
                  </v-icon>
                  <span class="red--text font-weight-bold text--lightem-1"
                    >هنوز کالایی به فاکتور اضافه نشده است</span
                  >
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pointer"
                  @click="goToDetails(data.item.id)"
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(totalPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  <span v-show="false">{{ reactivity }}</span>
                  {{
                    (
                      Number(data.item.amount) * data.item.price
                    ).toLocaleString()
                  }}
                </div>
              </template>
              <template v-slot:cell(operation)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <span
                    class="pointer"
                    @click="removeItem(data.index, data.item)"
                  >
                    <v-icon>$Delete</v-icon></span
                  >
                </div>
              </template>
            </b-table>
            <div>
              <hr class="mt-5" />
              <div class="mb-9" v-if="invoiceData.useRoyaltyCredit">
                <span class="font-weight-bold primary--text">
                  <v-icon class="me-1" style="color: #7c4dff !important"
                    >mdi-alert-octagram-outline</v-icon
                  >
                  در این خرید از اعتبار استفاده شده است.</span
                >
              </div>
              <div>
                <v-col xl="12" lg="12" md="12" cols="12" class="p-0">
                  <v-row>
                    <v-col xl="6" lg="6" md="12" cols="12">
                      <v-row v-if="!invoiceData.useRoyaltyCredit">
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            تخفیف (تومان)
                          </span>
                        </v-col>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            {{
                              Number(invoiceData.discount).toLocaleString()
                            }}</span
                          >
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            مبلغ اعتبار (تومان)
                          </span>
                        </v-col>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            {{
                              Number(
                                invoiceData.royaltyDiscount
                              ).toLocaleString()
                            }}</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- <v-col xl="6" lg="6" md="12" cols="12">
                      <v-row>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            مالیات (تومان)
                          </span>
                        </v-col>
                        <v-col
                          v-if="invoiceData.details"
                          xl="6"
                          lg="6"
                          md="6"
                          cols="12"
                        >
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            {{
                              parseInt(
                                ((invoiceData.details
                                  .map(
                                    (x) => Number(x.price) * Number(x.amount)
                                  )
                                  .reduce((a, b) => a + b, 0) -
                                  invoiceData.discount) *
                                  invoiceData.vat) /
                                  100
                              ).toLocaleString()
                            }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col> -->
                  </v-row>
                </v-col>
                <v-col xl="12" lg="12" md="12" cols="12" class="p-0">
                  <v-row>
                    <v-col xl="6" lg="6" md="12" cols="12">
                      <v-row>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            قیمت کل (تومان)</span
                          >
                        </v-col>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            {{
                              Number(computedTotalPrice).toLocaleString()
                            }}</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col xl="6" lg="6" md="12" cols="12">
                      <v-row>
                        <v-col xl="6" lg="6" md="6" cols="12">
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            هزینه ارسال (تومان)
                          </span>
                        </v-col>
                        <v-col
                          v-if="invoiceData.shippingCost"
                          xl="6"
                          lg="6"
                          md="6"
                          cols="12"
                        >
                          <span class="fs-medium2 ml-1 font-weight-bold">
                            {{
                              parseInt(
                                invoiceData.shippingCost
                              ).toLocaleString()
                            }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </div>

              <v-row class="my-2">
                <v-col xl="6" lg="6" md="12" cols="12">
                  <v-row>
                    <v-col xl="6" lg="6" md="6" cols="12">
                      <span class="fs-large ml-1 font-weight-bold">
                        مبلغ پرداختی (تومان)
                      </span>
                    </v-col>
                    <v-col
                      v-if="invoiceData.totalPayablePrice"
                      xl="6"
                      lg="6"
                      md="6"
                      cols="12"
                    >
                      <span class="fs-large ml-1 font-weight-bold">
                        {{
                          parseInt(
                            invoiceData.totalPayablePrice
                          ).toLocaleString()
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="mt-8 pa-8 payment-box">
            <h4 class="box-title fs-large font-weight-bold">آدرس</h4>
            <v-row>
              <v-col xl="6" md="6" lg="6" sm="6" xs="6" cols="12">
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    آدرس:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.addressForReceipt }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col xl="6" md="6" lg="6" sm="6" xs="6" cols="12">
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    کد پستی:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.shopCustomerPostalCode }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col xl="6" md="6" lg="6" sm="6" xs="6" cols="12">
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    استان:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.shopCustomerStateName }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col xl="6" md="6" lg="6" sm="6" xs="6" cols="12">
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    شهر:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.shopCustomerCityName }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col
                xl="6"
                md="6"
                lg="6"
                sm="6"
                xs="6"
                cols="12"
                v-if="invoiceData.shopCustomerDistrict"
              >
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    منطقه:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.shopCustomerDistrict }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col
                xl="6"
                md="6"
                lg="6"
                sm="6"
                xs="6"
                cols="12"
                v-if="invoiceData.shopCustomerAddressMobile"
              >
                <div class="item-AddressesUser lastitem d-flex">
                  <h6 class="fs-medium font-weight-bold shoppurple--text ml-1">
                    موبایل گیرنده:
                  </h6>
                  <div class="addrss__details d-flex">
                    <p class="fs-medium font-weight-bold secondary--text ms-2">
                      {{ invoiceData.shopCustomerAddressMobile }}
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mt-8 pa-8 payment-box">
            <h4 class="box-title fs-large font-weight-bold">اطلاعات پرداخت</h4>
            <v-row class="mt-1" style="font-size: 15px">
              <v-col xl="3" lg="3" md="4" sx="12" xs="12">
                <b class="fs-large ml-1">نوع پرداخت: </b>
                <span class="fs-large">{{ invoiceData.type }}</span>
              </v-col>
            </v-row>
            <v-card class="mt-4 py-4">
              <h1 class="fs-large font-weight-bold mt-4 mr-4">
                لیست پرداخت ها
              </h1>
              <!-- <v-btn
                v-if="invoiceData.readyToShip"
                color="success"
                class="text-center"
                @click="send(item)"
                :disabled="invoiceData.isShipped"
              >
                ارسال کالا
              </v-btn> -->
              <!-- <v-btn
                primary
                color="success"
                class="text-center"
                @click="openChequeDialog(item)"
              >
                ثبت اطلاعات چک
              </v-btn> -->
              <v-data-table
                class="w-100"
                fixed-header
                :headers="paymentHeaders"
                :items="[invoiceData.income]"
                no-results-text="موردی برای نمایش وجود ندارد!"
                hide-default-footer
                loading-text="در حال بارگذاری اطلاعات..."
              >
                <template slot="no-data">
                  <div class="font-weight-bold">
                    موردی برای نمایش وجود ندارد!
                  </div>
                </template>

                <template v-slot:[`item.index`]="{ index }">
                  <span class="font-weight-bold fs-small">
                    {{ index + perPage * (currentPage - 1) + 1 }}
                  </span>
                </template>
                <template v-slot:[`item.date`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.date }}
                  </span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ Number(item.amount).toLocaleString() }} تومان
                  </span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.status }}
                  </span>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.description }}
                  </span>
                </template>
              </v-data-table>
            </v-card>
            <v-card class="mt-4 py-4" v-if="invoiceData.type == 'قسطی'">
              <v-row class="mt-1" style="font-size: 15px">
                <v-col xl="8" lg="8" md="8" sx="12" xs="12" class="d-flex">
                  <h1 class="fs-large font-weight-bold mt-4 mr-4">
                    لیست چک ها
                  </h1>
                </v-col>
              </v-row>
              <v-data-table
                class="w-100"
                fixed-header
                :headers="chequeHeaders"
                :items="invoiceData.installmentIncomes"
                no-results-text="موردی برای نمایش وجود ندارد!"
                hide-default-footer
                loading-text="در حال بارگذاری اطلاعات..."
              >
                <template slot="no-data">
                  <div class="font-weight-bold">
                    موردی برای نمایش وجود ندارد!
                  </div>
                </template>
                <!-- <template v-slot:[`item.status`]="{ item }">
                  <div class="font-weight-bold">
                    <v-chip color="primary">
                      {{ item.status }}
                    </v-chip>
                  </div>
                </template> -->
                <template v-slot:[`item.index`]="{ index }">
                  <span class="font-weight-bold fs-small">
                    {{ index + perPage * (currentPage - 1) + 1 }}
                  </span>
                </template>
                <template v-slot:[`item.chequeNo`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.chequeNo }}
                  </span>
                </template>
                <template v-slot:[`item.chequeBank`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.chequeBank }}
                  </span>
                </template>

                <template v-slot:[`item.chequeDate`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.chequeDate }}
                  </span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ Number(item.amount).toLocaleString() }} تومان
                  </span>
                </template>
                <template v-slot:[`item.chequeStatus`]="{ item }">
                  <span class="font-weight-bold fs-small">
                    {{ item.chequeStatus }}
                  </span>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    v-if="item.chequeStatus == 'در انتظار ثبت'"
                    class="primary white--text"
                    @click="openChequeDialog(item)"
                  >
                    ثبت چک
                  </v-btn>
                  <v-btn
                    v-if="item.chequeStatus == 'ثبت شده'"
                    class="secondary white--text"
                    disabled
                  >
                    ویرایش چک
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
            <v-row class="mt-4" style="font-size: 15px">
              <v-col>
                <b class="fs-medium">توضیحات: </b>
                <span class="fs-small">{{ invoiceData.description }}</span>
              </v-col>
            </v-row>
          </div>
          <div class="mt-7 text-left">
            <v-btn @click="printReceipt()" class="orange-mainBtn" width="120"
              >پرینت فاکتور
              <v-icon class="ms-2" color="white">mdi-printer </v-icon>
            </v-btn>
            <v-btn
              width="120"
              v-if="invoiceData.readyToShip"
              class="text-center blue-mainBtn ms-3"
              @click="send()"
              :disabled="invoiceData.isShipped"
            >
              ارسال کالا
              <v-icon class="ms-2 white--text"> mdi-bike-fast </v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
      <!-- receipt -->
      <v-card class="pa-2" style="direction: rtl" v-show="false" id="Receipt">
        <b-card
          style="border: 0px solid black; border-radius: 10px; padding: 10px"
        >
          <table style="border: 0px solid black !important">
            <tr>
              <td style="border: 0px solid black !important">
                <span
                  ><b>نام مشتری:</b>
                  {{
                    customers.filter(
                      (x) => x.id == invoiceData.shopCustomerId
                    )[0]
                      ? customers.filter(
                          (x) => x.id == invoiceData.shopCustomerId
                        )[0].name
                      : "-"
                  }}
                  ( کد مشتری:
                  {{
                    invoiceData.shopCustomerCode
                      ? invoiceData.shopCustomerCode
                      : " - "
                  }})
                </span>
              </td>
              <td style="border: 0px solid black !important; text-align: left">
                <span><b>تاریخ خرید:</b> {{ invoiceData.date }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px solid black !important">
                <span
                  ><b>شماره همراه مشتری:</b>
                  {{ invoiceData.shopCustomerMobile }}</span
                >
              </td>
              <td style="border: 0px solid black !important; text-align: left">
                <span><b>شماره سفارش:</b> {{ invoiceData.code }}</span>
              </td>
            </tr>
          </table>
        </b-card>
        <hr />
        <br />
        <div
          style="
            border: 1px solid black;
            border-radius: 10px;
            padding: 25px;
            position: relative;
          "
        >
          <b-card
            header-bg-variant="primary"
            header-text-variant="white"
            v-if="invoiceData.details"
          >
            <b-table
              v-if="invoiceData.details.length"
              responsive
              show-empty
              :items="invoiceData.details"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-icon class="red--text text--lightem-1 me-2"
                    >mdi-alert-circle-outline
                  </v-icon>
                  <span class="red--text font-weight-bold text--lightem-1"
                    >به نظر میرسد خطایی رخ داده است! کالایی در این سبد خرید وجود
                    ندارد!</span
                  >
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(totalPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  <span v-show="false">{{ reactivity }}</span>
                  {{
                    (
                      Number(data.item.amount) * data.item.price
                    ).toLocaleString()
                  }}
                </div>
              </template>
            </b-table>
          </b-card>
          <br />

          <table
            style="border: 0px solid black !important; break-inside: avoid"
          >
            <tr>
              <td style="border: 0px solid black !important">
                <span
                  >قیمت کل (تومان):
                  {{ Number(computedTotalPrice).toLocaleString() }}</span
                >
              </td>
            </tr>
            <tr>
              <td style="border: 0px solid black !important">
                <span>
                  هزینه ارسال (تومان):
                  {{ Number(invoiceData.shippingCost).toLocaleString() }}</span
                >
              </td>
            </tr>
            <!-- <tr>
              <td
                v-if="invoiceData.details"
                colspan="2"
                style="border: 0px solid black !important"
              >
                <span
                  >مالیات (تومان):
                  {{
                    parseInt(
                      ((invoiceData.details
                        .map((x) => Number(x.price) * Number(x.amount))
                        .reduce((a, b) => a + b, 0) -
                        invoiceData.discount) *
                        invoiceData.vat) /
                        100
                    ).toLocaleString()
                  }}</span
                >
              </td>
            </tr> -->
          </table>
          <hr />
          <table
            style="border: 0px solid black !important; break-inside: avoid"
          >
            <tr>
              <td
                colspan="2"
                style="border: 0px solid black !important; font-size: 17px"
              >
                <b>
                  <span
                    >مبلغ پرداختی (تومان):
                    {{
                      parseInt(invoiceData.totalPayablePrice).toLocaleString()
                    }}</span
                  ></b
                >
              </td>
            </tr>
          </table>
        </div>
        <br />
        <br />
        <div
          style="
            border: 1px solid black;
            border-radius: 10px;
            padding: 20px;
            position: relative;
          "
        >
          <div
            style="
              font-size: 20px;
              position: absolute;
              top: -15px;
              right: 20px;
              background-color: #fff;
              padding: 0 15px;
            "
          >
            اطلاعات ارسال
          </div>
          <span>
            <b>آدرس: </b>
            {{ invoiceData.addressForReceipt }}
          </span>
          <br />
          <span>
            <b>کد پستی: </b>
            {{ invoiceData.shopCustomerPostalCode }}
          </span>
          <br />
          <span>
            <b>استان: </b>
            {{ invoiceData.shopCustomerStateName }}
          </span>
          <br />
          <span>
            <b>شهر: </b>
            {{ invoiceData.shopCustomerCityName }}
          </span>
          <br />
          <span v-if="invoiceData.shopCustomerDistrict">
            <b>منطقه: </b>
            {{ invoiceData.shopCustomerDistrict }}
          </span>
        </div>
        <br />
        <br />
        <div
          style="
            border: 1px solid black;
            border-radius: 10px;
            padding: 20px;
            position: relative;
          "
        >
          <div
            style="
              font-size: 20px;
              position: absolute;
              top: -15px;
              right: 20px;
              background-color: #fff;
              padding: 0 15px;
            "
          >
            <b>اطلاعات پرداخت</b>
          </div>
          <table
            style="border: 0px solid black !important; break-inside: avoid"
          >
            <tr>
              <td colspan="2" style="border: 0px solid black !important">
                <b class="fs-large ml-1">نوع پرداخت:</b>
                <span class="font-weight-bold fs-small">
                  {{ invoiceData.type }}
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px solid black !important">
                <v-data-table
                  class="w-100"
                  fixed-header
                  :headers="paymentHeaders"
                  :items="[invoiceData.income]"
                  no-results-text="موردی برای نمایش وجود ندارد!"
                  hide-default-footer
                  loading-text="در حال بارگذاری اطلاعات..."
                >
                  <template slot="no-data">
                    <div class="font-weight-bold">
                      موردی برای نمایش وجود ندارد!
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ index + perPage * (currentPage - 1) + 1 }}
                    </div>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ item.date }}
                    </div>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(item.amount).toLocaleString() }} تومان
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ item.status }}
                    </div>
                  </template>
                  <template v-slot:[`item.description`]="{ item }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ item.description }}
                    </div>
                  </template>
                </v-data-table>
              </td>
            </tr>
            <tr v-if="invoiceData.type == 'قسطی'">
              <td colspan="2" style="border: 0px solid black !important">
                <h1 class="fs-large font-weight-bold mt-4 mr-4">لیست چک ها</h1>

                <v-data-table
                  class="w-100"
                  fixed-header
                  :headers="chequeHeaders"
                  :items="invoiceData.installmentIncomes"
                  no-results-text="موردی برای نمایش وجود ندارد!"
                  hide-default-footer
                  loading-text="در حال بارگذاری اطلاعات..."
                >
                  <template slot="no-data">
                    <div class="font-weight-bold">
                      موردی برای نمایش وجود ندارد!
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.status`]="{ item }">
                  <div class="font-weight-bold">
                    <v-chip color="primary">
                      {{ item.status }}
                    </v-chip>
                  </div>
                </template> -->
                  <template v-slot:[`item.index`]="{ index }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ index + perPage * (currentPage - 1) + 1 }}
                    </div>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(item.amount).toLocaleString() }} تومان
                    </div>
                  </template>
                </v-data-table>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px solid black !important">
                <b class="fs-medium">توضیحات: </b>
                <span class="fs-small">{{ invoiceData.description }}</span>
              </td>
            </tr>
          </table>
        </div>
      </v-card>
    </div>
    <!--Cheque-->
    <v-dialog v-model="chequeDialog" width="600px">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between"
          style="background: #fff; color: #000"
        >
          <div>
            <span class="me-1"> ثبت اطلاعات چک </span>
            <span style="color: #000; cursor: pointer">{{
              selectedInvoice.code
            }}</span>
          </div>
          <div>
            <v-icon
              style="color: red; font-size: 20px"
              @click="chequeDialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>
        <hr />
        <v-card-text>
          <v-row>
            <v-col md="6" cols="12"
              >مبلغ چک:
              {{ Number(selectedCheque.amount).toLocaleString() }}
              تومان</v-col
            >
            <v-col md="6" cols="12"
              >تاریخ چک: {{ selectedCheque.chequeDate }}</v-col
            >
            <v-col md="6" cols="12">
              <v-text-field
                :disabled="selectedCheque.chequeStatus == 'ثبت شده'"
                density="compact"
                variant="outlined"
                v-model="selectedCheque.chequeNo"
                placeholder="شماره چک"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                :disabled="selectedCheque.chequeStatus == 'ثبت شده'"
                density="compact"
                variant="outlined"
                v-model="selectedCheque.chequeBank"
                placeholder="شعبه بانک"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-end pb-4">
            <v-btn
              color="success"
              :disabled="
                !selectedCheque.chequeBank ||
                !selectedCheque.chequeNo ||
                selectedCheque.chequeStatus == 'ثبت شده'
              "
              @click="submitCheque(index)"
              class="me-3"
              >ثبت چک</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Send-->
    <v-dialog v-model="openSendDialog" width="400">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ارسال کالا
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="openSendDialog = false"
                ><v-icon>mdi-close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-textarea
          class="pa-3 pb-0"
          outlined
          placeholder="در صورت تمایل توضیحات خود را وارد نمایید"
          v-model="sendDescription"
        >
        </v-textarea>
        <div class="text-left pe-3 pb-4 pt-0 d-flex justify-end">
          <v-btn color="success" class="me-3" @click="confirmSend()">
            تایید
          </v-btn>
          <v-btn color="error" @click="openSendDialog = false"> بستن </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import VueBarcode from "vue-barcode";
import moment from "moment-jalaali";
import { AtomSpinner, HalfCircleSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    AtomSpinner,
    HalfCircleSpinner,
    barcode: VueBarcode,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      moment: moment,
      guide: false,
      reactivity: false,
      snackbar: false,
      errorSnackbar: false,
      busy: false,
      text: "",
      selectedCheque: [],
      customers: [],
      products: [],
      newCustomer: {},
      check: {},
      selectedInvoice: {},
      sendDescription: "",
      titleFilter: "",
      barcodeFilter: "",
      perPage: 5,
      currentPage: 1,
      productsDialog: false,
      chequeDialog: false,
      productsLoading: false,
      gettingCustomers: false,
      newCustomerDialog: false,
      openSendDialog: false,
      pageLoading: false,
      paymentHeaders: [
        {
          text: "ردیف",
          sortable: false,
          value: "index",
        },
        {
          text: "تاریخ",
          sortable: false,
          value: "date",
        },

        {
          text: "مبلغ",
          sortable: false,
          value: "amount",
        },
        {
          text: "وضیعت ",
          sortable: false,
          value: "status",
        },
        {
          text: "توضیحات",
          sortable: false,
          value: "description",
        },
      ],
      chequeHeaders: [
        {
          text: "ردیف",
          sortable: false,
          value: "index",
        },
        {
          text: "شماره چک",
          sortable: false,
          value: "chequeNo",
        },
        {
          text: "نام بانک",
          sortable: false,
          value: "chequeBank",
        },

        {
          text: "تاریخ چک",
          sortable: false,
          value: "chequeDate",
        },
        {
          text: "مبلغ",
          sortable: false,
          value: "amount",
        },
        {
          text: "وضیعت چک",
          sortable: false,
          value: "chequeStatus",
        },
        {
          text: "عملیات",
          sortable: false,
          value: "action",
        },
      ],
      invoiceData: {
        income: {
          chequeNo: "",
          chequeBank: "",
          chequeDate: "",
        },
      },
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت واحد (تومان)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (تومان)" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      tiers: [
        { value: "coper", text: "برنزی" },
        { value: "silver", text: "نقره‌ای" },
        { value: "gold", text: "طلایی" },
        { value: "diamond", text: "الماس" },
      ],
    };
  },
  methods: {
    goToDetails(id) {
      let link = "/shop/editproduct/" + id;
      window.open(link, "_blank");
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.guide = false;
      this.newCustomerDialog = true;
    },
    reduceItem(item, index, amount) {
      let myamount = item.amount;
      if (myamount <= amount) {
        this.invoiceData.details.splice(index, 1);
      } else {
        this.invoiceData.details[index].amount =
          Number(this.invoiceData.details[index].amount) - Number(amount);
        this.reactivity = !this.reactivity;
      }
      item.sum = item.sum + amount;
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            this.searchCustomer();
            if (this.tempCustomer) {
              this.invoiceData.shopCustomerId = this.tempCustomer;
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
    searchCustomer() {
      this.busy = true;
      let myCustomer = {};
      myCustomer = this.customers.filter(
        (x) => x.mobile == this.invoiceData.shopCustomerMobile
      );
      if (myCustomer.length == 0) {
        this.newCustomer = {
          mobile: this.invoiceData.shopCustomerMobile,
          type: "naturalPerson",
        };
        this.newCustomerDialog = true;
      } else {
        this.invoiceData.shopCustomerId = myCustomer[0].id;
      }
      this.busy = false;
    },
    getData() {
      this.pageLoading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/getInfo",
        {
          shopInvoiceId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoiceData = res.data;

            this.invoiceData.type = this.paymentTypes.filter(
              (x) => x.text == this.invoiceData.income.type
            )[0].value;
            setTimeout(() => {
              this.pageLoading = false;
            }, 400);
          } else {
            this.toast(res.data, "error");
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.pageLoading = false;
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    goToPrint() {
      const url = this.$router.resolve({
        path: `/printPreview/single/${this.$route.params.id}`,
      }).href;
      window.open(url, "_blank");
    },
    send(invoiceData) {
      this.openSendDialog = true;
      this.selectedPaid = invoiceData;
    },
    openChequeDialog(item) {
      this.selectedCheque = JSON.parse(JSON.stringify(item));
      setTimeout(() => {
        for (let key in this.selectedCheque) {
          if (this.selectedCheque[key] == "-") {
            this.selectedCheque[key] = "";
          }
        }
      }, 300);
      setTimeout(() => {
        this.chequeDialog = true;
      }, 300);
    },
    confirmSend() {
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/sales/shipInvoice/" +
          this.$route.params.id,
        { description: this.sendDescription },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.$router.push("/manager/salesmanager");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openSendDialog = false;
        });
    },
    submitCheque() {
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/payments/submitCheque/" +
          this.selectedCheque.id,
        {
          chequeNo: this.selectedCheque.chequeNo,
          chequeBank: this.selectedCheque.chequeBank,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.chequeDialog = false;
            this.selectedCheque = {};
            this.toast(res.data.message, "success");
            this.getData();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedTotalPrice() {
      if (this.invoiceData.details) {
        let total = 0;
        this.invoiceData.details.forEach((x) => {
          total = total + Number(x.amount) * Number(x.price);
        });
        this.reactivity = !this.reactivity;
        return total;
      }
    },
    computedCheckInfo() {
      if (this.invoiceData.type == "cheque") {
        if (
          !this.invoiceData.income.chequeNo ||
          !this.invoiceData.income.chequeBank ||
          !this.invoiceData.income.chequeDate
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedBtn() {
      if (this.invoiceData.type && this.invoiceData.shopCustomerId) {
        if (this.invoiceData.type == "cheque") {
          if (
            !this.invoiceData.income.chequeNo ||
            !this.invoiceData.income.chequeBank ||
            !this.invoiceData.income.chequeDate
          ) {
            return true;
          } else return false;
        } else return false;
      } else return true;
    },
  },
  mounted() {
    this.getData();
    this.getCustomers();
  },
};
</script>

<style lang="scss">
.new-invoice {
  .customSelect {
    width: 300px;
    border-radius: 8px;

    .v-text-field .v-input__control,
    .v-text-field {
      fieldset {
        height: 48px !important;
        border-radius: 8px !important;
      }
    }

    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }
    }

    .v-label {
      background-color: #fff;
      padding: 2px 6px 0;
    }
  }

  .bordered {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 25px;
    min-height: 400px;

    .custom-input {
      .v-input__slot {
        width: 100% !important;
      }

      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }

      .mdi:before {
        margin-top: 6px;
      }
    }

    .customSelect {
      width: 100% !important;

      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
    }
  }

  .add-btn {
    width: 24px;
    height: 24px;
    border: 1px solid #12b8a1;
    border-radius: 4px;
    background-color: #edfdf7;
    display: flex;
    justify-content: center;
    color: #12b8a1;
    cursor: pointer;
    user-select: none;

    span {
      transform: translateY(-3px);
    }
  }

  .remove-btn {
    min-width: 24px;
    height: 24px;
    border: 1px solid #f3536e;
    border-radius: 4px;
    background-color: #ffe4e9;
    display: flex;
    justify-content: center;
    color: #f3536e;
    padding: 3px;
    cursor: pointer;
    user-select: none;

    span {
      transform: translateY(-3px);
    }
  }
}

.purple-icon {
  path {
    stroke: #7c4dff !important;
  }
}

.payment-box {
  border: 1px solid #ccc;
  border-radius: 10px;
  position: relative;

  .box-title {
    position: absolute;
    top: -13px;
    background-color: #fff;
    padding: 0 15px;
  }
}
</style>
